/**
 * Turns a spoken/typed phrase into a dog command. Deliberately loose: the
 * recogniser mishears, and a dog only listens for the words it knows anyway.
 */
export type Command = 'sit' | 'down' | 'come' | 'stay' | 'stand' | 'name' | Trick;
export type Trick = 'spin' | 'shake' | 'rollover' | 'speak' | 'playdead';
export const TRICKS: Trick[] = ['spin', 'shake', 'rollover', 'speak', 'playdead'];
export const TRICK_LABEL: Record<Trick, string> = { spin: 'spin', shake: 'shake', rollover: 'roll over', speak: 'speak', playdead: 'play dead' };

// checked in order: earlier entries win when a phrase matches several
const RULES: [Command, RegExp][] = [
  // tricks first: "roll over" contains no other keyword but "play dead" must beat "down"-ish mishearings
  ['rollover', /\b(roll over|rollover|roll|rolled)\b/],
  ['playdead', /\b(play dead|bang|dead)\b/],
  ['spin', /\b(spin|spins|twirl|turn around)\b/],
  ['shake', /\b(shake|paw|shake hands|high five)\b/],
  ['speak', /\b(speak|talk|bark)\b/],
  ['sit', /\b(sit|sits|sitting|set)\b/],
  ['down', /\b(lie|lay|down|lie down|lay down)\b/],
  ['come', /\b(come|comes|here|c'mon|common)\b/],
  ['stay', /\b(stay|wait)\b/],
  ['stand', /\b(stand|up|get up)\b/],
];

/** @param names the dog's name and likely mishearings of it */
export function parseCommand(text: string, names: string[]): Command | null {
  const t = text.toLowerCase();
  for (const [cmd, re] of RULES) if (re.test(t)) return cmd;
  for (const n of names) if (new RegExp(`\\b${n}\\b`).test(t)) return 'name';
  return null;
}
